import cn from 'classnames';
import type { OSName } from '#dn-types/downloads.ts';
import { OSIcon } from './OSIcon.tsx';
import styles from './OSCard.module.css';

type Props = {
  os: Exclude<OSName | 'Mobile', 'FreeBSD' | 'iOS' | 'Android' | 'Docker'> | 'Other';
  children?: React.ReactNode;
};

export function OSCard({ os, children }: Props) {
  return (
    <div className={styles.OSCard}>
      <h3 className={cn('h5', styles.OSCard_title)}>
        <OSIcon os={os} />
        {os}
      </h3>
      {children}
    </div>
  );
}
